import React from 'react';
import Badge from '../ui/Badge';
import { categoryLabel, difficultyMeta } from './constants';

/**
 * QuestionCard - compact summary used in the Question Bank list and the
 * session-side question picker.
 *
 * Props:
 *   question   - QuestionResponse from the API
 *   onClick    - optional click handler (opens detail drawer)
 *   action     - optional React node rendered top-right (e.g. "Attach" button)
 */
export default function QuestionCard({ question, onClick, action }) {
  const diff = difficultyMeta(question.difficulty);
  const tone = diff.tone === 'success' ? 'green'
             : diff.tone === 'warning' ? 'amber'
             : diff.tone === 'danger'  ? 'red' : 'slate';

  return (
    <article
      onClick={onClick}
      className={`group card p-4 shadow-soft
                  transition-all ${onClick ? 'cursor-pointer hover:-translate-y-0.5 hover:shadow-medium hover:border-teal-300' : ''}`}
    >
      <div className="flex items-start gap-3">
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-slate-900 truncate">
            {question.title}
          </h3>
          {question.description && (
            <p className="mt-1 text-xs text-slate-500 line-clamp-2">
              {question.description}
            </p>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>

      <div className="mt-3 flex flex-wrap items-center gap-2">
        <Badge label={categoryLabel(question.category)} color="teal" size="xs" />
        <Badge label={diff.label} color={tone} size="xs" />
        {question.timeEstimateMinutes != null && (
          <span className="text-[10px] text-slate-500">
            ⏱ {question.timeEstimateMinutes} min
          </span>
        )}
        {question.tags?.slice(0, 3).map((t) => (
          <Badge key={t} label={`#${t}`} color="slate" size="xs" />
        ))}
        {(question.tags?.length || 0) > 3 && (
          <span className="text-[10px] text-slate-400">+{question.tags.length - 3}</span>
        )}
        {!question.active && (
          <Badge label="Archived" color="gray" size="xs" />
        )}
      </div>
    </article>
  );
}
